import {
	Component,
	OnInit
} from '@angular/core';
import {
	NgModel,
	FormGroup,
	FormBuilder,
	Validators,
	FormControl
} from '@angular/forms';
import {
	Router
} from '@angular/router';
import {
	EmailService, 
	RMessage
} from '../services/email.component';
@Component({
	selector: 'refer-a-friend',
	templateUrl: '../views/refer-a-friend.component.html',
	providers: [EmailService]
})
export class ReferAFriendComponent{
	form: FormGroup;
	message:RMessage = {
		email: "",
		phone: "",
		your_name: "",
		their_name: "",
		message: ""
	};

	constructor(private emailService:EmailService, 
							private formBuilder:FormBuilder,
							private router:Router)
	{

	}
	ngOnInit(){
		this.form = this.formBuilder.group({
			their_name: new FormControl(this.message.their_name, [Validators.required, Validators.minLength(2)]),
			your_name: new FormControl(this.message.your_name, [Validators.required, Validators.minLength(2)]),
			email: new FormControl(this.message.email, [Validators.required, Validators.email]),
			phone: new FormControl(this.message.phone),
			message: new FormControl(null),
		});
	}
	isFieldValid(field: string){
		return !this.form.get(field).valid && this.form.get(field).touched;
	}
	displayFieldCss(field: string){
		return {
			'has-error': this.isFieldValid(field),
			'has-feedback': this.isFieldValid(field)
		};
	}
	validateField(field: string){
		return (field !== '' && field !== null);
	}
	sendMail(message: RMessage){
		// console.log("Send mail called");
		for(var key in this.form.controls){
			message[key] = this.form.controls[key].value;
			// console.log(key+": "+message[key])
		}
		var we = this.validateField(message.their_name);
		var are = this.validateField(message.your_name);
		var okie = this.validateField(message.email);

		if(!(we && are && okie)){
		  Object.keys(this.form.controls).forEach(key => {
		  	if(this.isFieldValid(key)){
			  	this.form.get(key).markAsDirty();
			    this.form.get(key).markAsTouched();
			    this.form.updateValueAndValidity();
		  	}
		  });
			return;
		}
		// console.log('Sending referral')
		this.emailService.sendRefer(message).subscribe(res => {
			this.router.navigateByUrl('/refer-complete');
			// console.log('ReferUsComponent Success', res)
		}, 
		error =>{
			this.router.navigateByUrl('/refer-error');
			// console.error('ReferUsComponent Error', error);
		})
	}
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/refer-a-friend.component.ts